import CustomSearchInput from "components/CustomSearchInput/CustomSearchInput";
import FoundField from "components/SearchInDialogAlert/components/FoundField/FoundField";
import { useEffect, useState } from "react";
import { requestGetTeachers } from "services/general";
import usePrevious from "utils/hooks/usePrevious";

const TutorFilter = ({
    disabled, 
    loadingRequest,
    value,
    onChange
}) => {
    //#region States
    const [tutorListFound, setTutorListFound] = useState([]);
    const [tutorSearched, setTutorSearched] = useState("");
    const [tutorSelectedName, setTutorSelectedName] = useState(null);
    //#endregion
    const prevValue = usePrevious(value);
    useEffect(() => {
        // Limpiando campos si 
        if (value || typeof prevValue === "undefined" || value === prevValue) return;
        setTutorSelectedName(null);
        setTutorSearched("");
    }, [value]);
    //#region Functions
    const clearField = () => {
        setTutorSelectedName(null);
        setTutorSearched("");
        onChange("");
    }
    const selectTutor = ({ id, name }) => {
        setTutorSelectedName(name);
        onChange(id);
    }
    const [timeoutId, setTimeoutId] = useState(null);
    const searchTutor = value => {
        setTutorSearched(value)
        if (!value) return;
        clearTimeout(timeoutId);
        const newTimeoutId = setTimeout(async () => {
            loadingRequest.show("Buscando tutor...");
            const data = await requestGetTeachers(value, "Refuerzo");
            loadingRequest.hide();
            setTutorListFound(data.map(({ codigoDocente, nombreDocente }) => ({
                id: codigoDocente, 
                name: nombreDocente
            })));
        }, 300);
        setTimeoutId(newTimeoutId);
    }
    //#endregion
    if (tutorSelectedName)
        return (
            <FoundField 
                width="230px"
                label="Tutor"
                text={tutorSelectedName}
                button={{
                    text: "Limpiar",
                    onClick: clearField
                }}/>
        );
    return (
        <CustomSearchInput 
            label="Tutor"
            placeholder="Busca un tutor"
            disabled={disabled}
            getText={({ name }) => name}
            width="230px"
            alignItem="start"
            dataFound={tutorListFound}
            onBlur={() => setTutorListFound([])}
            foundItemText={tutorSearched}
            selectDataItem={selectTutor}
            maxLength={300}
            minLength={1}
            handlerItemSearched={searchTutor}
            positionFoundBlock="absolute"/>
    );
}

export default TutorFilter;